<template>
  <div>
    <div v-if="loading" class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <img v-else-if="reciboUrl" :class="imgClass" :src="reciboUrl" alt="Recibo">
    <p v-else class="text-muted mb-0">No se pudo cargar el recibo.</p>
  </div>
</template>

<script>
import Security from "../security";

export default {
  name: "ReciboProtegido",
  props: {
    slug: {
      type: String,
      required: true,
    },
    imgClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      reciboUrl: "",
      loading: false,
    };
  },
  watch: {
    slug: {
      immediate: true,
      handler() {
        this.loadRecibo();
      },
    },
  },
  beforeUnmount() {
    this.revokeReciboUrl();
  },
  methods: {
    revokeReciboUrl() {
      if (this.reciboUrl) {
        URL.revokeObjectURL(this.reciboUrl);
        this.reciboUrl = "";
      }
    },
    async loadRecibo() {
      if (!this.slug) return;

      this.revokeReciboUrl();
      this.loading = true;
      try {
        this.reciboUrl = await Security.authenticatedBlobUrl(`/admin/pagos/recibo/${encodeURIComponent(this.slug)}`);
      } catch (error) {
        console.error(error);
        this.reciboUrl = "";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
